import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import { forbiddenPath, notFoundPath } from 'common/config/urls';
import { SIGN_IN_URL } from 'common/constants/login';
import { COMPANY_TYPE, FIRM_TYPE, FUND_INVESTMENTS_TYPE, FUND_TYPE, USER_TYPE } from 'common/constants/pageTypes';
import { CompanyContainer as CompanyContainerView, UserContainer as UserContainerView } from 'components';
import { CustomRouteElement } from 'components/CustomRoute/CustomRoute';
import { DASHBOARD_COMPANY_SLUG, DASHBOARD_WORKBOARD_SLUG } from 'dashboard409a/common/constants';
import { DashboardLayout } from 'dashboard409a/layouts';
import { Dashboard as DashboardView } from 'dashboard409a/pages';
import { FUND_INVESTMENTS_PATH } from 'pages/FundInvestments/common/urls';
import { FundInvestmentContainer } from 'pages/FundInvestments/components';
import { AuthLayout, Main as MainLayout, Minimal as MinimalLayout, TaskLayout } from './layouts';
import {
  ActivateAccount as ActivateAccountView,
  Firms as FirmsView,
  Funds as FundsView,
  Login as LoginView,
  NotFound as NotFoundView,
  ProcessManagement as ProcessManagementView,
  ResetPasswordConfirm as ResetPasswordConfirmView,
  SignUp as SignUpView,
  SsoErrorView,
  SsoExchange as SsoExchangeView,
} from './pages';

const Routes = () => (
  <RouterRoutes>
    <Route path="/" element={<Navigate to={SIGN_IN_URL} replace />} />
    <Route path="/sign-up" element={<CustomRouteElement component={SignUpView} layout={AuthLayout} />} />
    <Route
      path="/users/reset_password/:uid/:token"
      element={<CustomRouteElement component={ResetPasswordConfirmView} isPrivate={false} />}
    />
    <Route
      path="/activate-account/:uid/:token"
      element={<CustomRouteElement component={ActivateAccountView} layout={MinimalLayout} />}
    />
    <Route path={SIGN_IN_URL} element={<CustomRouteElement component={LoginView} />} />

    {/* Error handlers */}
    <Route path={notFoundPath} element={<CustomRouteElement component={NotFoundView} />} />
    <Route path={forbiddenPath} element={<CustomRouteElement component={NotFoundView} />} />

    {/* Firms */}
    <Route
      path="/firms/:firmSlugParam/:tableSlugParam"
      element={
        <CustomRouteElement
          component={FirmsView}
          isPrivate
          layout={props => <MainLayout pageType={FIRM_TYPE} {...props} />}
        />
      }
    />

    {/* Funds */}
    <Route
      path="/firms/:firmSlugParam/funds/:fundSlugParam/:tableSlugParam"
      element={
        <CustomRouteElement
          component={FundsView}
          isPrivate
          layout={props => <MainLayout pageType={FUND_TYPE} {...props} />}
        />
      }
    />

    {/* Companies */}
    <Route
      path="/firms/:firmSlugParam/companies/:companySlugParam/:tableSlugParam"
      element={
        <CustomRouteElement
          component={CompanyContainerView}
          isPrivate
          layout={props => <MainLayout pageType={COMPANY_TYPE} {...props} />}
        />
      }
    />

    {/* Fund Investments */}
    <Route
      path={FUND_INVESTMENTS_PATH}
      element={
        <CustomRouteElement
          component={FundInvestmentContainer}
          isPrivate
          layout={props => <MainLayout pageType={FUND_INVESTMENTS_TYPE} {...props} />}
        />
      }
    />

    {/* Users */}
    <Route
      path="/firms/:firmSlugParam/users/:tabSlugParam"
      element={
        <CustomRouteElement
          component={UserContainerView}
          isPrivate
          layout={props => <MainLayout pageType={USER_TYPE} {...props} />}
        />
      }
    />
    <Route
      path="/firms/:firmSlugParam/users/:userIdParam/:tabSlugParam"
      element={
        <CustomRouteElement
          component={UserContainerView}
          isPrivate
          layout={props => <MainLayout pageType={USER_TYPE} {...props} />}
        />
      }
    />

    {/* Process Management */}
    <Route
      path="/:processType/requests/:requestId/:hmacToken/:portal?"
      element={<CustomRouteElement component={ProcessManagementView} layout={TaskLayout} />}
    />

    {/* 409A Dashboard */}
    <Route
      path={`${DASHBOARD_COMPANY_SLUG}/:tableSlugParam`}
      element={
        <CustomRouteElement component={DashboardView} isPrivate layout={props => <DashboardLayout {...props} />} />
      }
    />
    <Route
      path={`${DASHBOARD_COMPANY_SLUG}/:tableSlugParam/:valuationId`}
      element={
        <CustomRouteElement component={DashboardView} isPrivate layout={props => <DashboardLayout {...props} />} />
      }
    />

    {/* Workboard - New simplified structure */}
    <Route
      path={`${DASHBOARD_WORKBOARD_SLUG}/:tabSlugParam`}
      element={
        <CustomRouteElement component={DashboardView} isPrivate layout={props => <DashboardLayout {...props} />} />
      }
    />
    {/* SSO error */}
    <Route path="/sso/error" element={<CustomRouteElement component={SsoErrorView} />} />

    {/* SSO token exchange (public) */}
    <Route path="/sso/callback" element={<CustomRouteElement component={SsoExchangeView} />} />
    {/* Not found */}
    <Route path="*" element={<Navigate to={notFoundPath} replace />} />
  </RouterRoutes>
);

export default Routes;
